/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from "@angular/core";
import { StationDto } from "src/app/services/api";

@Pipe({ name: "orderStationsByWaterLevel" })
export class OrderStationsByWaterLevelPipe implements PipeTransform {
  public transform(elements: StationDto[]): StationDto[] {
    if (!elements) return [];
    return ([...elements] || []).sort((a, b) => this.sortStationsByWaterLevel(a, b));
  }

  private isNumber(value: any): boolean {
    return typeof value === "number" && value !== null;
  }

  public sortStationsByWaterLevel(a: StationDto, b: StationDto): number {
    if (!this.isNumber(a.waterLevel) && !this.isNumber(b.waterLevel)) return a.id.localeCompare(b.id);
    else if (!this.isNumber(a.waterLevel)) return 1;
    else if (!this.isNumber(b.waterLevel)) return -1;
    const result = b.waterLevel - a.waterLevel;
    return result ? result : a.id.localeCompare(b.id);
  }
}
